import React from 'react';

import ConfirmDialog from 'components/confirm-dialog';
import { t } from 'state/intl/translations';

import { logCTAEvent } from '../../utils';
import { BodyComponent } from '../body-component';

interface IUnsavedChangesDialog {
  showDialog: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const UnsavedChangesDialog = ({
  showDialog,
  onConfirm,
  onCancel,
}: IUnsavedChangesDialog) => {
  const heading = t('unsavedChangesModalHeader');
  const content = t('unsavedChangesModalDescription');

  const saveLabel = t('saveChanges');
  const discardLabel = t('leaveWithoutSaving');

  return showDialog ? (
    <ConfirmDialog
      showDialog={showDialog}
      modalAppearanceEventMessage="Confirmation: Product Wizard - Discard Unsaved Changes"
      bodyComponent={<BodyComponent heading={heading} content={content} />}
      confirmLabel={saveLabel}
      cancelLabel={discardLabel}
      onConfirm={() => {
        logCTAEvent(saveLabel);
        onConfirm();
      }}
      onCancel={() => {
        logCTAEvent(discardLabel);
        onCancel();
      }}
    />
  ) : null;
};
